import { useTranslation } from "react-i18next";

export type SpecialTagBadgeKind = "provider" | "untagged";

// Cada clase escrita entera: Tailwind escanea el texto fuente, y un hue armado
// en runtime (`bg-${hue}-500/15`) no genera CSS (ver INSPECTION_STATUS_PALETTE).
// Morado es el mismo hue de los estados `provider_*`; el índigo de la pipa sin
// tag no lo usa ningún estado, y tiene que ser así: esa inspección ya lleva al
// lado la píldora de su estado normal, y dos píldoras del mismo color se leen
// como una.
const TONE: Record<SpecialTagBadgeKind, string> = {
  provider: "bg-purple-500/15 text-purple-400 border border-purple-500/30",
  untagged: "bg-indigo-500/15 text-indigo-400 border border-indigo-500/30",
};

const ICON: Record<SpecialTagBadgeKind, string> = {
  provider: "ri-briefcase-4-line",
  untagged: "ri-price-tag-3-line",
};

/**
 * Insignia "Especial · Proveedor" / "Especial · Pipa sin tag".
 *
 * Una sola para Accesos y para el historial de inspecciones: las dos pantallas
 * marcan lo mismo —esta fila salió de un tag compartido del patio, no de la
 * tarjeta de una unidad— y con dos copias terminarían diciéndolo distinto.
 */
export default function SpecialTagBadge({
  kind,
  className = "",
}: {
  kind: SpecialTagBadgeKind;
  className?: string;
}) {
  const { t } = useTranslation("truckYard");
  const label =
    kind === "provider"
      ? t("specialTags.badge.provider")
      : t("specialTags.badge.untagged");
  const hint =
    kind === "provider"
      ? t("specialTags.badgeHint.provider")
      : t("specialTags.badgeHint.untagged");
  return (
    <span
      title={hint}
      className={`inline-flex items-center gap-1 text-xs px-2 py-0.5 rounded-full font-medium whitespace-nowrap ${TONE[kind]} ${className}`}
    >
      <i className={`${ICON[kind]} text-xs`} aria-hidden="true"></i>
      {label}
    </span>
  );
}
